export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBW4EDpbQvv7tRXsNpSqVLwkaPYVep17xU',
    authDomain: 'clinik360-dev.firebaseapp.com',
    projectId: 'clinik360-dev',
    storageBucket: 'clinik360-dev.firebasestorage.app',
    messagingSenderId: '215849311614',
    appId: '1:215849311614:web:49af5d8a2388de2170a72f',
    measurementId: 'G-PY4NDRVT2V',
  },
};
